import app from "./app";

export default {
  app
};



// WEBPACK FOOTER //
// ./src/store/modules/index.js